import { buildToolStructuredData } from '../components/Seo'

const calculatorPage = ({ path, name, description, keywords }) => ({
  title: `${name} | Calculadoras de Engenharia`,
  description,
  canonicalPath: path,
  type: 'article',
  structuredData: buildToolStructuredData({ name, description, keywords }),
})

const collectionPage = ({ path, title, description, keywords }) => ({
  title: `${title} | Calculadoras de Engenharia`,
  description,
  canonicalPath: path,
  type: 'website',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: title,
    description,
    inLanguage: 'pt-BR',
    keywords,
  },
})

const homeDescription =
  'Coleção gratuita de calculadoras para concreto, aço, alvenaria estrutural, geotecnia, instalações elétricas e hidrossanitárias, com validação em tempo real e histórico de cálculos.'

export const pageSeoConfig = {
  '/': {
    title: 'Calculadoras de Engenharia Online | Calculadoras de Engenharia',
    description: homeDescription,
    canonicalPath: '/',
    type: 'website',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Calculadoras de Engenharia',
      description: homeDescription,
      inLanguage: 'pt-BR',
    },
  },
  '/concreto': collectionPage({
    path: '/concreto',
    title: 'Calculadoras de Concreto Armado',
    description: 'Calculadoras de vigas de concreto sob flexão, cisalhamento, torção.',
    keywords: ['concreto armado', 'flexão', 'cisalhamento', 'torção', 'viga', 'concreto', 'inércia'],
  }),
  '/concreto/flexao': calculatorPage({
    path: '/concreto/flexao',
    name: 'Calculadora de Flexão em Concreto Armado',
    description:
      'Dimensione a armadura de vigas e lajes em flexão conforme NBR 6118, incluindo domínio da armação e verificação de armadura mínima.',
    keywords: ['concreto', 'vigas', 'lajes', 'flexão', '6118', 'armadura', 'longitudinal'],
  }),
  '/concreto/flexo-tracao': calculatorPage({
    path: '/concreto/flexo-tracao',
    name: 'Calculadora de Flexo-Tração em Concreto Armado',
    description:
      'Dimensione a armadura longitudinal de seções retangulares em flexão composta com tração conforme a NBR 6118, com identificação automática do domínio de deformação.',
    keywords: ['concreto', 'vigas', 'flexo-tração', 'flexão composta', '6118', 'armadura', 'longitudinal'],
  }),
  '/concreto/cisalhamento': calculatorPage({
    path: '/concreto/cisalhamento',
    name: 'Calculadora de Cisalhamento em Concreto Armado',
    description: 'Cálculo o cortante e defina estribos para vigas de concreto armadado com todas as verificações.',
    keywords: ['concreto', 'vigas', 'lajes', 'cisalhamento', 'estribos', 'cortante'],
  }),
  '/concreto/escada-longitudinal-patamar': calculatorPage({
    path: '/concreto/escada-longitudinal-patamar',
    name: 'Calculadora de Escada em Concreto Armado',
    description: 'Dimensione escadas de concreto armado com patamar intermediário conforme NBR 6118.',
    keywords: ['concreto', 'escada', 'lances', 'patamar', 'armadura', 'dimensionamento', 'NBR 6118'],
  }),
  '/concreto/torcao': calculatorPage({
    path: '/concreto/torcao',
    name: 'Calculadora de Torção em Concreto Armado',
    description: 'Dimensione vigas de concreto submetidas à torção e obtenha as armações.',
    keywords: ['concreto', 'torção', 'armadura', 'armação', 'vigas'],
  }),
  '/concreto/consolo': calculatorPage({
    path: '/concreto/consolo',
    name: 'Calculadora de Consolo de Concreto Armado',
    description: 'Dimensione consolos de concreto armado e obtenha armadura necessária.',
    keywords: ['concreto', 'consolo', 'armadura', 'vigas', 'compressao diagonal'],
  }),
  '/concreto/fundacao-parede': calculatorPage({
    path: '/concreto/fundacao-parede',
    name: 'Calculadora de Fundação de Parede',
    description: 'Dimensione a área de aço para fundações corridas em concreto sob paredes.',
    keywords: ['fundação', 'corrida', 'parede', 'concreto', 'armação', 'armadura'],
  }),
  '/concreto/inercia-equivalente': calculatorPage({
    path: '/concreto/inercia-equivalente',
    name: 'Calculadora da Inércia Equivalente',
    description: 'Calcule a inércia equivalente para vigas de concreto pelo método de Branson.',
    keywords: ['inércia equivalente', 'branson', 'concreto', 'deformações'],
  }),
  '/concreto/fadiga-armadura-longitudinal': calculatorPage({
    path: '/concreto/fadiga-armadura-longitudinal',
    name: 'Calculadora de Fadiga da Armadura Longitudinal',
    description:
      'Verifique a fadiga da armadura longitudinal de seções de concreto armado comparando a variação de tensão no aço com o limite da bitola, conforme NBR 6118.',
    keywords: ['fadiga', 'armadura longitudinal', 'concreto', 'variação de tensão', '6118', 'estádio ii'],
  }),
  '/concreto/fadiga-armadura-transversal': calculatorPage({
    path: '/concreto/fadiga-armadura-transversal',
    name: 'Calculadora de Fadiga da Armadura Transversal',
    description:
      'Verifique a fadiga da armadura transversal (estribos) de seções retangulares de concreto armado calculando a variação de tensão no aço entre o cortante máximo e mínimo, conforme NBR 6118.',
    keywords: ['fadiga', 'armadura transversal', 'estribos', 'concreto', 'cisalhamento', '6118'],
  }),
  '/concreto/sapata-isolada': calculatorPage({
    path: '/concreto/sapata-isolada',
    name: 'Calculadora de Sapata Isolada',
    description:
      'Dimensione sapatas isoladas de concreto armado com carga centrada ou excêntrica conforme NBR 6118 e NBR 6122.',
    keywords: ['sapata isolada', 'fundação', 'concreto armado', 'excentricidade', 'NBR 6118', 'NBR 6122'],
  }),
  '/concreto/momento-area': calculatorPage({
    path: '/concreto/momento-area',
    name: 'Calculadora de Momento por Área de Aço',
    description:
      'Calcule o momento fletor resistente de seções retangulares de concreto armado a partir da área de aço existente.',
    keywords: ['concreto armado', 'momento resistente', 'área de aço', 'verificação', 'NBR 6118'],
  }),
  '/concreto/ancoragem': calculatorPage({
    path: '/concreto/ancoragem',
    name: 'Calculadora de Ancoragem em Concreto Armado',
    description:
      'Verifique a ancoragem de barras longitudinais no apoio e dimensione grampos complementares conforme a NBR 6118.',
    keywords: ['concreto armado', 'ancoragem', 'grampo', 'apoio', 'comprimento de ancoragem', 'NBR 6118'],
  }),
  '/concreto/camada-armadura': calculatorPage({
    path: '/concreto/camada-armadura',
    name: 'Calculadora de Distribuição de Barras em uma Camada',
    description:
      'Calcule a quantidade máxima de barras longitudinais que cabem em uma única camada de uma viga de concreto armado conforme a NBR 6118.',
    keywords: ['concreto armado', 'armadura', 'camada', 'espaçamento', 'barras longitudinais', 'estribo', 'NBR 6118'],
  }),
  '/concreto/flexo-compressao-obliqua': calculatorPage({
    path: '/concreto/flexo-compressao-obliqua',
    name: 'Calculadora de Flexo-Compressão Oblíqua em Concreto Armado',
    description:
      'Verifique seções retangulares de concreto armado submetidas a força normal e momentos fletores em dois eixos por análise de fibras 2D, com envoltória de interação N-Mx-My conforme a NBR 6118.',
    keywords: [
      'concreto armado',
      'flexo-compressão oblíqua',
      'pilar',
      'envoltória de interação',
      'fibras 2D',
      'N-Mx-My',
      'NBR 6118',
    ],
  }),
  '/concreto/pilares': calculatorPage({
    path: '/concreto/pilares',
    name: 'Calculadora de Dimensionamento de Pilares em Concreto Armado',
    description:
      'Dimensione e verifique pilares de concreto armado considerando momento mínimo, efeitos de segunda ordem local e flexo-compressão oblíqua conforme NBR 6118:2014.',
    keywords: [
      'concreto armado',
      'pilares',
      'dimensionamento',
      'momento mínimo',
      'segunda ordem',
      'esbeltez',
      'flexo-compressão oblíqua',
      'NBR 6118',
    ],
  }),
  '/concreto/portico-2d': calculatorPage({
    path: '/concreto/portico-2d',
    name: 'Calculadora de Análise Matricial de Pórtico Plano 2D',
    description:
      'Resolva pórticos e vigas planas por análise matricial elástica linear com elemento de pórtico 2D, obtendo deslocamentos nodais, reações de apoio e esforços internos.',
    keywords: [
      'análise matricial',
      'pórtico plano',
      'elementos finitos',
      'deslocamentos',
      'reações de apoio',
      'esforços internos',
      'rigidez',
    ],
  }),
  '/concreto/grelha': calculatorPage({
    path: '/concreto/grelha',
    name: 'Calculadora de Análise Matricial de Grelha Plana',
    description:
      'Resolva grelhas planas por análise matricial elástica linear, obtendo deslocamentos nodais, reações de apoio e esforços internos de cortante, momento fletor e torção.',
    keywords: [
      'análise matricial',
      'grelha plana',
      'laje nervurada',
      'flexão',
      'torção',
      'elementos finitos',
      'rigidez',
    ],
  }),
  '/eletrica': collectionPage({
    path: '/eletrica',
    title: 'Calculadoras de Instalações Elétricas',
    description: 'Dimensione circuitos, disjuntores e eletrodutos com verificações rápidas.',
    keywords: ['elétrica', 'instalações', 'disjuntores', 'cabos', 'circuitos', 'eletrodutos', 'condutores'],
  }),
  '/eletrica/circuitos': calculatorPage({
    path: '/eletrica/circuitos',
    name: 'Calculadora de Circuitos Elétricos',
    description: 'Dimensione cabos e disjuntores para circuitos elétricos.',
    keywords: ['elétrica', 'cabos', 'circuitos', 'proteção', 'disjuntores'],
  }),
  '/eletrica/eletroduto': calculatorPage({
    path: '/eletrica/eletroduto',
    name: 'Calculadora de Eletrodutos',
    description: 'Dimensione eletrodutos avaliando fator de ocupação e quantidade de cabos.',
    keywords: ['elétrica', 'eletroduto', 'condutores', 'cabos'],
  }),
  '/eletrica/queda-de-tensao': calculatorPage({
    path: '/eletrica/queda-de-tensao',
    name: 'Calculadora de Queda de Tensão',
    description: 'Dimensione cabos de cobre ou calcule a queda de tensão em percursos com vários trechos.',
    keywords: ['elétrica', 'queda de tensão', 'cabos', 'condutores', 'dimensionamento', 'NBR 5410'],
  }),
  '/alvenaria': collectionPage({
    path: '/alvenaria',
    title: 'Calculadoras de Alvenaria Estrutural',
    description:
      'Calculadoras para compressão, flexão, cisalhamento para painéis, paredes, vergas e vigas em Alvenaria Estrutural.',
    keywords: ['alvenaria estrutural', 'estrutural', 'compressão', 'vigas', 'vergas', 'cisalhamento', 'flexão'],
  }),
  '/alvenaria/compressao': calculatorPage({
    path: '/alvenaria/compressao',
    name: 'Calculadora de Compressão em Alvenaria Estrutural',
    description: 'Obtenha a resistência de bloco necessária de acordo com a solicitação.',
    keywords: ['alvenaria estrutural', 'compressão', 'resistência', 'blocos', 'prisma'],
  }),
  '/alvenaria/flexao': calculatorPage({
    path: '/alvenaria/flexao',
    name: 'Calculadora de Flexão em Alvenaria Estrutural',
    description: 'Dimensione paredes e vigas de Alvenaria Estrutural sob flexão e obtenha a armadura.',
    keywords: ['alvenaria estrutural', 'flexão', 'vigas', 'paredes', 'armação', 'área de aço', 'armadura'],
  }),
  '/alvenaria/painel': calculatorPage({
    path: '/alvenaria/painel',
    name: 'Calculadora de Painel de Alvenaria Estrutrural',
    description: 'Obtenha os esforços de flexão em paineis de alvenaria estrutrural.',
    keywords: ['alvenaria estrutural', 'painel', 'flexão', 'esforços'],
  }),
  '/alvenaria/cisalhamento': calculatorPage({
    path: '/alvenaria/cisalhamento',
    name: 'Calculadora de Cisalhamento em Alvenaria Estrutural',
    description: 'Calcule a área de aço para paredes e vigas de alvenaria estrutural sob cisalhamento (cortante).',
    keywords: ['alvenaria estrutural', 'cisalhamento', 'cortante', 'armação'],
  }),
  '/alvenaria/parede': calculatorPage({
    path: '/alvenaria/parede',
    name: 'Verificação de Parede de Alvenaria Estrutural',
    description:
      'Verifique paredes de alvenaria estrutural considerando dimensões, materiais e carregamentos conforme a NBR 16868-1:2020.',
    keywords: ['alvenaria estrutural', 'parede', 'verificação', 'NBR 16868', 'carregamentos', 'geometria'],
  }),
  '/aco': collectionPage({
    path: '/aco',
    title: 'Calculadoras de Aço',
    description: 'Dimensione soldas, placas de base, perfis laminados e formados à frio em um so lugar.',
    keywords: ['aço', 'solda', 'placa de base', 'perfis laminados', 'compressão', 'flexão'],
  }),
  '/aco/solda-axial': calculatorPage({
    path: '/aco/solda-axial',
    name: 'Calculadora de Solda',
    description: 'Calcule as soldas necessárias para a sua ligação.',
    keywords: ['aço', 'solda', 'axial', 'ligações'],
  }),
  '/aco/base-rotulada': calculatorPage({
    path: '/aco/base-rotulada',
    name: 'Calculadora de Placa de Base Rotulada',
    description: 'Dimensione placas de base rotuladas com chumbadores.',
    keywords: ['aço', 'placa de base', 'chumbadores', 'fundações', 'ligações'],
  }),
  '/aco/laminado-flexao': calculatorPage({
    path: '/aco/laminado-flexao',
    name: 'Calculadora de Perfil Laminado sob Flexão',
    description: 'Verifique perfis laminados sob flexão conforme NBR 8800.',
    keywords: ['aço', 'perfil laminado', 'flexão', 'momento', 'NBR 8800'],
  }),
  '/aco/laminado-compressao': calculatorPage({
    path: '/aco/laminado-compressao',
    name: 'Calculadora de Perfil Laminado em Compressão',
    description: 'Dimensione perfis laminados em compressão considerando flambagem.',
    keywords: ['aço', 'compressão', 'perfil laminado', 'normal', 'flambagem'],
  }),
  '/aco/compressao-frio': calculatorPage({
    path: '/aco/compressao-frio',
    name: 'Calculadora de Perfil Formado à Frio em Compressão',
    description: 'Verifique perfis formados à frio em compressão conforme NBR 14762.',
    keywords: ['aço', 'formado à frio', 'compressão', 'NBR 14762'],
  }),
  '/aco/flexao-frio': calculatorPage({
    path: '/aco/flexao-frio',
    name: 'Calculadora de Perfil Formado à Frio em Flexão',
    description:
      'Dimensione perfis formados à frio em flexão simples pelo Método das Seções Efetivas conforme NBR 14762.',
    keywords: ['aço', 'formado à frio', 'flexão', 'seções efetivas', 'NBR 14762'],
  }),
  '/aco/chapa': calculatorPage({
    path: '/aco/chapa',
    name: 'Calculadora de Chapa de Piso em Aço',
    description: 'Dimensione chapas de piso em aço por deformação e resistência com verificação de peso próprio.',
    keywords: ['aço', 'chapa de piso', 'chapa xadrez', 'dimensionamento', 'NBR 8800'],
  }),
  '/aco/tubo-circular-flexao': calculatorPage({
    path: '/aco/tubo-circular-flexao',
    name: 'Calculadora de Tubo Circular à Flexão',
    description: 'Dimensione e verifique seções tubulares circulares em aço sob momento fletor conforme NBR 8800.',
    keywords: ['aço', 'tubo circular', 'flexão', 'seção tubular', 'NBR 8800'],
  }),
  '/geotecnia': collectionPage({
    path: '/geotecnia',
    title: 'Calculadoras de Geotecnia',
    description: 'Ferramentas para muros de arrimo e capacidade de carga de estacas.',
    keywords: ['geotecnia', 'estacas', 'fundações', 'arrimos', 'muros'],
  }),
  '/geotecnia/estaca': calculatorPage({
    path: '/geotecnia/estaca',
    name: 'Calculadora de estacas',
    description: 'Estime capacidade de carga de estacas pelos métodos de Aoki & Velloso e Décourt & Quaresma.',
    keywords: ['geotecnia', 'estacas', 'capacidade de carga', 'Décourt & Quaresma', 'Aoki & Velloso'],
  }),
  '/geotecnia/muro-flexao': calculatorPage({
    path: '/geotecnia/muro-flexao',
    name: 'Calculadora de Muro em Flexão',
    description: 'Avalie estabilidade e dimensionamento de muros em flexao e atrito de base.',
    keywords: ['geotecnia', 'muros de flexao', 'estabilidade', 'tombamento', 'deslizamento'],
  }),
  '/hidrossanitario': collectionPage({
    path: '/hidrossanitario',
    title: 'Calculadoras de Instalações Hidrossanitárias',
    description: 'Dimensione fossas sépticas, reservatórios e sistemas pluviais rapidamente.',
    keywords: ['hidrossanitário', 'instalações', 'fossa séptica', 'pluvial', 'reservatório'],
  }),
  '/hidrossanitario/fossa': calculatorPage({
    path: '/hidrossanitario/fossa',
    name: 'Calculadora de Fossa Séptica',
    description: 'Dimensione fossas sépticas e obtenha as dimensões necessárias para sua obra.',
    keywords: ['fossa séptica', 'tratamento', 'hidrossanitário', 'instalações', 'dimensões'],
  }),
  '/hidrossanitario/reservatorio': calculatorPage({
    path: '/hidrossanitario/reservatorio',
    name: 'Calculadora de Reservatórios',
    description: 'Calcule volumes e dimensione reservatórios de água.',
    keywords: ['reservatório', 'água', 'hidrossanitário', 'instalações'],
  }),
  '/hidrossanitario/pluvial': calculatorPage({
    path: '/hidrossanitario/pluvial',
    name: 'Calculadora de Águas Pluviais',
    description: 'Dimensione calhas, condutores verticais e horizontais para águas pluviais.',
    keywords: [
      'pluvial',
      'águas pluviais',
      'drenagem',
      'hidrossanitário',
      'instalações',
      'calhas',
      'condutores verticais',
      'condutores horizontais',
    ],
  }),
}

export function getSeoForPath(pathname) {
  if (!pathname) return pageSeoConfig['/']

  const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') || '/' : '/'

  return pageSeoConfig[normalizedPath] || pageSeoConfig[pathname] || pageSeoConfig['/']
}
